import {Injectable} from "@angular/core";
import {KeycloakService} from "keycloak-angular";
import {defer, Observable} from "rxjs";
import {KeycloakLoginOptions} from "keycloak-js";
import {SettingsService} from "@supoui/core/services/settings.service";

@Injectable({providedIn: 'root'})
export class AuthenticationService {
  constructor(private keycloakService: KeycloakService, private settingsService: SettingsService) {
  }

  redirectToLoginPage(login?: string): Observable<void> {
    if (!!login) {
      const loginOptions: KeycloakLoginOptions = {loginHint: login};
      return defer(() => this.keycloakService.login(loginOptions));
    }
    return defer(() => this.keycloakService.login());
  }

  get userName(): string {
    return this.keycloakService.getUsername();
  }

  isLoggedIn(): Observable<boolean> {
    return defer(() => this.keycloakService.isLoggedIn());
  }

  logout(): Observable<void> {
    return defer(() => this.keycloakService.logout(this.settingsService.getKeycloakSettings().postLogoutRedirectUri));
  }
}
